// extracted by mini-css-extract-plugin
module.exports = {"icon":"Detail_icon__3khcT","iconDis":"Detail_iconDis__TlnO2"};